import { Action, createReducer, on } from "@ngrx/store";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import { WarehouseDTO } from "src/app/models/site-devices/warehouseDTO";
import { TankLevelGaugesDTO } from "src/app/models/tank-gauges/tank-gaugesDTO";
import * as TankGaugeActions from "../../actions/tank-gauges/tank-gauges.actions";

export interface TankGaugeState {
  isLoading: boolean;
  tankGauges: TankLevelGaugesDTO[];
  tankGaugeTypes: any[];
  tankgauge: TankLevelGaugesDTO;
  totalRecords: number;
  created: boolean;
  tankGaugeTableConfig: ColumnSorterInfo[];
  warehouses: WarehouseDTO[];
}

export const initialState: TankGaugeState = {
  isLoading: false,
  tankGauges: null,
  tankgauge: null,
  totalRecords: 0,
  created: false,
  tankGaugeTableConfig: null,
  warehouses: null,
  tankGaugeTypes: null,
};

const tankGaugeReducer = createReducer(
  initialState,
  on(TankGaugeActions.resetTankGaugeState, () => initialState),
  on(TankGaugeActions.getTankGauges, (state, { code }) => {
    return {
      ...state,
      code: code,
      isLoading: true,
    };
  }),
  on(TankGaugeActions.loadTankGauges, (state, { response }) => {
    return {
      ...state,
      tankGauges: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
      totalRecords: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(TankGaugeActions.getTankGaugeTypes, (state, { pageReq }) => {
    return {
      ...state,
      pageReq: pageReq,
      isLoading: true,
    };
  }),
  on(TankGaugeActions.loadTankGaugeTypes, (state, { response }) => {
    return {
      ...state,
      tankGaugeTypes: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
    };
  }),
  on(TankGaugeActions.getWarehouses, (state, { options }) => {
    return {
      ...state,
      options: options,
      isLoading: true,
    };
  }),
  on(TankGaugeActions.loadWarehouses, (state, { response }) => {
    return {
      ...state,
      warehouses: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
    };
  }),
  on(TankGaugeActions.getTankGaugeTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(TankGaugeActions.loadTankGaugeTableConfig, (state, { response }) => {
    return {
      ...state,
      tankGaugeTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(TankGaugeActions.saveTankGaugeTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(TankGaugeActions.getTankGauge, (state) => {
    return {
      ...state,
      isLoading: true,
      created: false,
    };
  }),
  on(TankGaugeActions.loadTankGauge, (state, { tankGauge }) => ({
    ...state,
    tankgauge: (tankGauge as any).result,
    isLoading: false,
    error: null,
  })),
  on(TankGaugeActions.resetTankGauge, (state) => {
    return {
      ...state,
      tankgauge: null,
      error: null,
    };
  }),
  on(TankGaugeActions.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(TankGaugeActions.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(
    TankGaugeActions.createTankGauge,
    TankGaugeActions.updateTankGauge,
    (state) => {
      return {
        ...state,
        isLoading: true,
      };
    }
  )
);

export function reducer(state: TankGaugeState | undefined, action: Action) {
  return tankGaugeReducer(state, action);
}
